"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 2019-03-25
 */

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * @author JMr
 */


var SelloutReleaseItemConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutReleaseItemConverter, _DataObjectConverter_);

  function SelloutReleaseItemConverter() {
    _classCallCheck(this, SelloutReleaseItemConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemConverter).apply(this, arguments));
  }

  return SelloutReleaseItemConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutReleaseItemConverter = SelloutReleaseItemConverter;